module.exports = __webpack_public_path__ + "img/second_right.9e16db70.svg";